import { useState, useEffect } from 'react';
import { LOG_IN } from '../routes/index.routes';
import authService from '../services/auth.service';
import { toast } from "react-toastify";












export const useFetch = (url, fakeData = "") => {

  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(fakeData);

  const isAuthenticated = authService.isAuthenticated();



  useEffect(() => {

    const abortCont = new AbortController();

    fetch(url, { signal: abortCont.signal, })
      .then(res => {

        if (res.status === 404) {
          console.error(res);

          if (isAuthenticated) {
            toast.error(`Something went wrong. Please login and try again`);
            window.location.href = LOG_IN;
          }
        }
        if (!res.ok) {
          throw Error("Could not connect to the server");
        }
        return res.json();
      }).then((data) => {
        setData(data);
        setIsPending(false);
      }).catch(err => {

        toast.error(`Something went wrong. Please  and try again`);
        console.error(err);

        if (err.name === "AbortError") {
          setError(err.message);
          toast.error("Fetch Aborted.");
          console.error("Fetch Aborted.");
          throw Error("Fetch Aborted.");
        } else {
          setError(err.message);
          throw Error("An error occurred while trying to fetch from the remote server.");
        }
      });

    return () => abortCont.abort();
  }, [url, isAuthenticated]);

  return { isPending, error, data, };
};
